export const maskPersonalInfo = (input: string): string => {
    if (!input || typeof input !== "string") return "";
  
    const length = input.length;
  
    if (length < 4) {
      return input; // 4자 미만이면 그대로 반환
    } else if (length >= 4 && length <= 6) {
      return input[0] + "*".repeat(length - 2) + input[length - 1];
    } else {
      return input.slice(0, 2) + "*".repeat(length - 4) + input.slice(-2);
    }
  };
  
  export const isEmailFromDomain = (email: string, domain: string): boolean => {
    if (!email || !domain) return false;
  
    // 이메일 정규식 검증
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return false;
  
    // 도메인 추출
    const emailDomain = email.split("@")[1];
    
    return emailDomain === domain;
  };

  export type FitOptions = {
    fontFamily?: string;
    fontWeight?: number | string;
    min?: number;        // 최소 폰트 크기
    max?: number;        // 최대 폰트 크기
    padding?: number;    // 좌우 여백(px) 합산 2*padding을 빼서 계산
    tolerance?: number;  // 이 정도 오차면 OK
  };
  
  export function fitFontSizeToWidth(
    text: string,
    targetWidth: number,
    options: FitOptions = {}
  ): number {
    const {
      fontFamily = 'Pretendard, Roboto, Arial, sans-serif',
      fontWeight = 700,
      min = 10,
      max = 200,
      padding = 0,
      tolerance = 0.5,
    } = options;
  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx || !targetWidth || targetWidth <= 0) return min;
  
    const available = Math.max(targetWidth - padding * 2, 0);
  
    const measure = (size: number) => {
      ctx.font = `${fontWeight} ${size}px ${fontFamily}`;
      return ctx.measureText(text).width;
    };
  
    // 이분 탐색으로 폰트 크기 찾기
    let lo = min;
    let hi = max;
    let best = min;
  
    while (hi - lo > tolerance) {
      const mid = (lo + hi) / 2;
      const w = measure(mid);
      if (w <= available) {
        best = mid;      // 더 키울 수 있음
        lo = mid;
      } else {
        hi = mid;        // 너무 큼 → 줄이기
      }
    }
    return Math.max(min, Math.min(best, max));
  }